import React from "react";
import { Carousel, CarouselProps } from "react-responsive-carousel";

export interface CarouselComponentPropsModel
  extends Partial<Omit<CarouselProps, "children">> {
  children: JSX.Element | JSX.Element[];
  items?: JSX.Element[];
  noItemMessage?: string;
}

const CarouselComponent: React.FunctionComponent<
  CarouselComponentPropsModel
> = (props) => {
  const { children, noItemMessage = "No items to display" } = props;

  if (!children || React.Children.count(children) === 0) {
    return <div>{noItemMessage}</div>;
  }

  return (
    <Carousel
      autoPlay
      showThumbs={false}
      infiniteLoop
      dynamicHeight={false}
      showStatus={false}
      showIndicators={false}
      interval={2000}
      {...props}
    >
      {React.Children.toArray(children).map((v) => v as React.ReactElement)}
    </Carousel>
  );
};

export default CarouselComponent;
